import React from "react";

import {
  Menu,
  Container,
  Dropdown,
  Header,
  Grid,
  Sidebar,
  Icon
} from "semantic-ui-react";
import GridRow from "semantic-ui-react/dist/commonjs/collections/Grid/GridRow";

const Box = ({
  currency,
  componentData,
  locationsData,
  totalRevenueSubtitle = true,
  totalOnline = {},
  nestedComponentData,
  user_type,
  percent
}) => {
  const displaySubText = () => {
    let iconName = "caret down";
    let iconColor = "red";
    if (componentData) {
      let directionData = componentData.data;
      if (directionData && directionData.arrow) {
        if (directionData.arrow == "up") {
          iconName = "caret up";
          iconColor = "green";
        }
        return (
          <Grid.Row style={styles.heading}>
            <span style={styles.headingOne}>
              <Icon
                style={styles.icon}
                name={iconName}
                type="font-awesome"
                color={iconColor}
              />{" "}
              {directionData.percent} %
            </span>
            <span style={styles.comparision}>
              Change comparison: 7-day Daily Average
            </span>
          </Grid.Row>
        );
      }
    }
    if (totalRevenueSubtitle && user_type === "shell_head_office") {
      return (
        <Grid.Row>
          <span
            style={{ ...styles.comparision, marginTop: "14px", width: "100%" }}
          >
            {totalOnline && totalOnline.header}{" "}
            {totalOnline && totalOnline.value}
          </span>
        </Grid.Row>
      );
    }
    return <Grid.Row></Grid.Row>;
  };
  const displayLocationText = () => {
    return (
      <div>
        <Grid.Row
          style={{ ...styles.heading, display: "flex", flexDirection: "row" }}
        >
          {locationsData.map((item, key) => {
            return (
              <span
                key={key}
                style={{
                  ...styles.headingOne,
                  padding: "0 1em",
                  borderRight: key == 2 ? "none" : "1px solid"
                }}
              >
                {item.header}: {item.value}
              </span>
            );
          })}
        </Grid.Row>
      </div>
    );
  };
  return (
    <Grid.Column verticalAlign="middle">
      <div style={styles.boxMain}>
        <Grid.Row style={styles.heading}>
          <Header as="h5" style={styles.headingText}>
            {componentData.header}
          </Header>
        </Grid.Row>
        <Grid.Row style={styles.textValue}>
          {currency} {componentData.value} {percent ? ' %' :'' }
        </Grid.Row>
        {locationsData && locationsData.length
          ? displayLocationText()
          : displaySubText()}
        {nestedComponentData ? 
          <div>
            <Grid.Row style={{ ...styles.heading, display: "flex", flexDirection: "row" }}>
                <span
                  style={{
                    ...styles.headingOne,
                    padding: "0 1em",
                  }}
                >
                  {nestedComponentData.text} {nestedComponentData.value}  
                </span>
            </Grid.Row>
          </div>
        :null}
        
      </div>
    </Grid.Column>
  );
};

const styles = {
  boxMain: {
    minHeight: 170,
    marginBottom: 30,
    marginTop: 15,
    paddingBottom: 20,
    paddingTop: 35,
    backgroundColor: "#ffffff",
    borderRadius: 5,
    textAlign: "center",
    boxShadow: "0 1px 6px rgba(0, 0, 0, 0.1)"
  },
  comparision: {
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 300,
    fontSize: 10,
    marginTop: 5
  },
  heading: {
    flex: 0,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: 5
  },
  headingOne: {
    fontSize: 14,
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 300,
    marginTop: 17
  },
  headingText: {
    fontSize: 16,
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 300,
    marginBottom: 8
  },
  icon: {
    height: 8,
    width: 10,
    justifyContent: "center",
    paddingTop: 0
  },
  textValue: {
    fontSize: 32,
    fontWeight: 400,
    flex: 0,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    fontFamily: "Roboto",
    color: "#313131"
  }
};

export default Box;



// WEBPACK FOOTER //
// ./src/components/Box/index.js